<div class="add-book-btn {{ style }}" (click)="showAddBookModal()">
    <button class="button-v2 --icon-only {{ btnClass }}">
        <fa-icon [icon]="['tg', 'plus']"></fa-icon>
    </button>
</div>
